document.addEventListener('DOMContentLoaded', function () {
  const blogButtons = document.querySelectorAll('.bloggle--nav-item');
  const blogContainer = document.querySelector('[data-blog-container]');
  let loading = false;
  let currentObserver = null;

  // Set active state based on current URL
  const currentPath = window.location.pathname;
  blogButtons.forEach((button) => {
    if (currentPath.includes(button.dataset.blogUrl)) {
      button.classList.add('bloggle--active');
    }
  });

  function setupInfiniteScroll() {
    const loadMore = document.querySelector('[data-load-more]');
    if (!loadMore) return;

    // Disconnect previous observer if it exists
    if (currentObserver) {
      currentObserver.disconnect();
    }

    const loadMoreContent = () => {
      if (loading) return;

      const nextUrlElement = loadMore.querySelector('[data-next-url]');
      const nextUrl = nextUrlElement?.value;

      if (!nextUrl) {
        loadMore.remove();
        return;
      }

      loading = true;

      fetch(nextUrl)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newArticles = doc.querySelector('[data-blog-container]').innerHTML;
          const nextPageUrl = doc.querySelector('[data-next-url]')?.value;

          blogContainer.insertAdjacentHTML('beforeend', newArticles);

          setTimeout(() => {
            blogContainer.querySelectorAll('.blog-articles__article:not(.loaded)').forEach((article) => {
              article.classList.add('loaded');
            });
          }, 100);

          if (nextPageUrl) {
            nextUrlElement.value = nextPageUrl;
          } else {
            loadMore.remove();
          }

          loading = false;
        });
    };

    // Create new observer
    currentObserver = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        loadMoreContent();
      }
    });

    currentObserver.observe(loadMore);
  }

  async function loadBlogPosts(blogHandle, url) {
    if (loading) return;
    loading = true;

    try {
      const response = await fetch(url);
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newArticles = doc.querySelector('[data-blog-container]').innerHTML;
      const loadMoreElement = doc.querySelector('[data-load-more]');

      blogContainer.innerHTML = newArticles;

      // Add loaded class to initial articles
      blogContainer.querySelectorAll('.blog-articles__article').forEach((article) => {
        article.classList.add('loaded');
      });

      // Update URL without page reload
      window.history.pushState({}, '', url);

      // Update active state
      blogButtons.forEach((btn) => {
        btn.classList.toggle('bloggle--active', btn.dataset.blogHandle === blogHandle);
      });

      // Append load more element if it exists in the new content
      if (loadMoreElement) {
        const existingLoadMore = document.querySelector('[data-load-more]');
        if (existingLoadMore) {
          existingLoadMore.remove();
        }
        blogContainer.insertAdjacentElement('afterend', loadMoreElement);
      }

      // Setup infinite scroll after content is loaded
      setupInfiniteScroll();
    } catch (error) {
      console.error('Error loading blog posts:', error);
    } finally {
      loading = false;
    }
  }

  // Handle blog navigation clicks
  blogButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const blogHandle = button.dataset.blogHandle;
      const blogUrl = button.dataset.blogUrl;
      loadBlogPosts(blogHandle, blogUrl);
    });
  });

  // Setup initial infinite scroll
  setupInfiniteScroll();

  // Search functionality
  const searchInput = document.getElementById('bloggle--input_search');
  const resultContainer = document.getElementById('bloggle--search_results');

  searchInput.addEventListener('input', function (e) {
    const searchValue = e.target.value;

    if (searchValue.length > 1) {
      resultContainer.style.display = 'block';
      const suggestUrl = '/search/suggest.json?q=' + searchValue + '&resources[type]=article';

      fetch(suggestUrl)
        .then((response) => response.json())
        .then((data) => {
          const articles = data.resources.results.articles;
          if (articles.length > 0) {
            let resultsHtml = articles
              .map(
                (article) =>
                  `<div class="bloggle--search_result">
                  <a class="bloggle--search_result_link" href="${article.url}">${article.title}</a>
                </div>`
              )
              .join('');
            resultContainer.innerHTML = resultsHtml;
          } else {
            resultContainer.innerHTML = '';
          }
        });
    } else {
      resultContainer.innerHTML = '';
      resultContainer.style.display = 'none';
    }
  });
});
